import { useEffect, useState } from 'react'
import { getRewardClaimHistory } from '../api/endpoints';

const useFetchRewardClaimHistory = (address, type) => {
    const [rewardClaimHistory, setRewardClaimHistory] = useState([]);
    const fetchRewardClaimHistory = async () => {
        try {
            const res = await getRewardClaimHistory(address, type);
            setRewardClaimHistory(res?.data);
        } catch (error) {
            console.log("fetchRewardClaimHistory error", error);
        }
    }
    useEffect(() => {
        fetchRewardClaimHistory();
    }, [address, type])
    return { rewardClaimHistory }
}

export default useFetchRewardClaimHistory